import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { useTheme } from '../../';
export const DropdownDivider = ({ className, ...props }) => {
    const theme = useTheme().theme.dropdown.floating.divider;
    return _jsx("div", { className: twMerge(theme, className), ...props });
};
